import { createSlice } from "@reduxjs/toolkit";

import {
  createBillingAddress,
  deleteBillingAddress,
  fetchBillingAddresses,
  IBillingAddress,
  setDefaultBillingAddress,
  updateBillingAddress,
} from "../actions/billingAddresses";

interface BillingAddressesState {
  addresses: IBillingAddress[];
  loading: boolean;
  error: string | null;
}

const initialState: BillingAddressesState = {
  addresses: [],
  loading: false,
  error: null,
};

const billingAddressesSlice = createSlice({
  name: "billingAddresses",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchBillingAddresses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBillingAddresses.fulfilled, (state, action) => {
        state.loading = false;
        state.addresses = action.payload;
      })
      .addCase(fetchBillingAddresses.rejected, (state) => {
        state.loading = false;
      })
      // Create
      .addCase(createBillingAddress.fulfilled, (state, action) => {
        const newAddr = action.payload;
        // If new one is default, unset others
        if (newAddr.isDefault) {
          state.addresses.forEach((a) => { a.isDefault = false; });
        }
        state.addresses.push(newAddr);
      })
      // Update
      .addCase(updateBillingAddress.fulfilled, (state, action) => {
        const updated = action.payload;
        if (updated.isDefault) {
          state.addresses.forEach((a) => { a.isDefault = false; });
        }
        const idx = state.addresses.findIndex((a) => a.id === updated.id);
        if (idx !== -1) state.addresses[idx] = updated;
      })
      // Delete
      .addCase(deleteBillingAddress.fulfilled, (state, action) => {
        state.addresses = state.addresses.filter((a) => a.id !== action.payload);
      })
      // Set default
      .addCase(setDefaultBillingAddress.fulfilled, (state, action) => {
        const updated = action.payload;
        state.addresses.forEach((a) => { a.isDefault = a.id === updated.id; });
      });
  },
});

export default billingAddressesSlice.reducer;
